import React from 'react'
import styles from "./FlexColumn.scss"

const FlexColumn = (props) => {
  let styleAdd = {
                width: '50%',
                minWidth: "0"
            };

  let classNames = '';

  if(props.col){
    styleAdd.width = 'calc(100% / '+ props.col+' - 2%)'
  }
  if(props.width){
    styleAdd.width = props.width
  }


  if(props.valign === "bottom"){
    classNames = classNames + ' ' + styles.valignBottom
  }

  if(props.align === "right"){
    classNames = classNames + ' ' + styles.alignRight
  }

  if(props.noPrint){
    classNames = classNames + ' ' + styles.noPrint
  }

  if(props.growSM){
    classNames = classNames + ' ' + styles.growSM
  }


  if(props.minWidth){
    styleAdd.minWidth = props.minWidth;
  }

  return (
  		<div className={classNames}
          style={styleAdd}>
          {props.children}
        </div>
  )
}

export default FlexColumn



// WEBPACK FOOTER //
// ./src/components/atoms/FlexColumn/index.js